import { EntityState } from "@ngrx/entity";

import { NotificationEntity } from '../entities';
import { LoadNotificationInputApiModel, UpdateNotificationInputApiModel } from '@app/store/http/models/input';

export interface NotificationState extends EntityState<NotificationEntity> {
    loading: boolean;
    loaded: boolean;
    cleared: boolean;
    clearing: boolean;
    count: number;
    query: LoadNotificationInputApiModel;
    countUnread: number;
    selectedId: number;
}